import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { ClientsBanner } from '../../components/ClientsBanner'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'

export default function NoRefusalPaydayLoans() {
    return (
        <div>
            <Seo
                title="Demande de prêt sur salaire sans aucun refus au Québec | Argent Aujourd’hui"
                description="Comparez les prêts sur salaire en ligne sans aucun refus sur notre site et choisissez l'option idéale pour vos besoins. Accédez aux meilleures offres."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt sur salaire sans aucun refus</h1>

                    {/* <p className="header-subtitle">...</p> */}

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <ClientsBanner />

            <Footer />
        </div>
    )
}
